import { handleEntriesTopWards } from "../../../api/entries";
import { ExportToExcel } from "../../../utils/exportExcel";
import { useQuery } from "@tanstack/react-query";
import { Button, Drawer, Form, Space, Input, Table } from "antd";
import { useState } from "react";
import { Download, Funnel, X } from "lucide-react";
import AllEntries from "./AllEntries";

const { Search } = Input;

export default function AllWards({ isVisible, setVisible, params }: any) {
  const [search, setSearch] = useState("");
  const [form] = Form.useForm();
  const [vehicles, setVehicles] = useState([]);
  const [showVehicles, setShowVehicles] = useState(false);
  const [wardId, setWardId] = useState("");
  const [title, setTitle] = useState("");

  const { data: entries, isLoading } = useQuery({
    queryKey: ["topWards", params],
    queryFn: () => handleEntriesTopWards({ params }),
  });

  const [pagination, setPagination] = useState<any>({
    page: 1,
    limit: 24,
    total: 0,
  });

  const handlePageChange = (e: any) => {
    setPagination((prev: any) => ({
      ...prev,
      page: e.current,
      limit: e.pageSize,
    }));
  };

  const handleClearSearch = () => {
    setSearch("");
    form.resetFields();
  };

  const columns: any = [
    {
      title: "S/N",
      width: 40,
      render: (record: any, text: any, index: any) => (
        <span className="text-gray-700 ml-2">
          {pagination?.page * pagination?.limit - pagination?.limit + index + 1}
        </span>
      ),
      fixed: "left",
    },
    {
      title: "DISTRICT",
      width: 100,
      render: (record: any) => (
        <span className="text-black">
          {record?.name}{" "}
          <span className="text-gray-500">({record?.region?.name})</span>
        </span>
      ),
    },
    {
      title: "ENTRIES",
      width: 140,
      fixed: "right",
      render: (record: any) => (
        <div className="flex items-center">
          <div className="mr-4">
            <span>
              <span className="font-bold">{record?.totalEntries}</span>
              <span className="mx-2">Entries</span>
            </span>
            <span className="text-gray-500">( {record?.percentage}% )</span>
          </div>
        </div>
      ),
    },
    {
      title: "ACTION",
      width: 100,
      fixed: "right",
      align: "right",
      render: (record: any) => {
        return (
          <div className="flex justify-end">
            <button
              onClick={() => {
                setVehicles(record?.individualModels);
                setShowVehicles(true);
              }}
              className="flex items-center border px-2 bg-blue-50 hover:bg-blue-100"
            >
              View All
            </button>
          </div>
        );
      },
    },
  ];
  return (
    <Drawer
      title={
        <div className="flex items-center">
          <span className="mr-2 text-lg uppercase">All Wards</span>
        </div>
      }
      placement={"right"}
      width={800}
      onClose={() => setVisible(!isVisible)}
      open={isVisible}
      closable={false}
      extra={
        <Space>
          <Button type="default" onClick={() => setVisible(!isVisible)} danger>
            <X size={16} />
          </Button>
        </Space>
      }
    >
      <div className="">
        <div className="flex justify-between items-center border-b border-gray-300 mb-2 pb-2 -mt-4 bg-white">
          <div className="flex">
            <Form layout="inline" form={form}>
              <Form.Item name="registration">
                <Search
                  placeholder="Search ward"
                  allowClear
                  onChange={(val: any) => {
                    setSearch(val.target.value);
                  }}
                  onSearch={(value: any) => {
                    setSearch(value);
                  }}
                />
              </Form.Item>

              <Button className="" onClick={() => handleClearSearch()}>
                <Funnel size={16} />
              </Button>
            </Form>
          </div>
          <div className="flex ">
            <button
              color="#E50000"
              className="flex justify-center items-center border p-1 hover:bg-green-100"
            >
              <Download size={16} />
              <span
                className="ml-2"
                onClick={() =>
                  ExportToExcel(
                    entries?.map((record: any, index: number) => {
                      return {
                        "S/N": index + 1,
                        Ward: record?.name || "-",
                        Region: record?.region?.name || "-",
                        Entries:
                          `${record?.totalEntries} ( ${record?.percentage}% )` ||
                          "-",
                      };
                    }),
                    "Wards.xlsx"
                  )
                }
              >
                Export To Excel
              </span>
            </button>
          </div>
        </div>

        <div className="shadow-sm">
          <Table
            size="small"
            dataSource={entries}
            columns={columns}
            scroll={{ y: 700, x: "max-content" }}
            rowKey="id"
            bordered
            pagination={{
              current: pagination?.page,
              pageSize: pagination?.limit,
              total: pagination?.total,
            }}
            rowClassName={"hover:bg-gray-100 cursor-pointer"}
            onChange={(e: any) => handlePageChange(e)}
            onRow={(record: any) => {
              return {
                onClick: () => {
                  setVehicles(record?.individualModels);
                  setWardId(record?._id);
                  setTitle(`${record?.name}`);
                  setShowVehicles(true);
                },
              };
            }}
            loading={isLoading}
          />
        </div>
      </div>
      <AllEntries
        isVisible={showVehicles}
        setVisible={setShowVehicles}
        vehicles={vehicles}
        wardId={wardId}
        title={title}
      />
    </Drawer>
  );
}
